// src/redux/Admin/scienceOfSelfViewSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    scienceOfSelfName: '',
};

const scienceOfSelfViewSlice = createSlice({
    name: 'scienceOfSelfView',
    initialState,
    reducers: {
        setScienceOfSelfName(state, action) {
            state.scienceOfSelfName = action.payload;
        },
        resetScienceOfSelfName(state) {
            state.scienceOfSelfName = '';
        },
    },
});

export const { setScienceOfSelfName, resetScienceOfSelfName } = scienceOfSelfViewSlice.actions;
export default scienceOfSelfViewSlice.reducer;
